import type { DisplayFootprint } from "./C1_eloDisplayCollision";

/** Receives the algorithm's footprint in model metres, outside the symbol's size transform. */
export function C1_EloCollisionFootprint({ footprint, view, px, itemId }: {
  footprint?: DisplayFootprint;
  view: { x1: number; y1: number };
  px: number;
  itemId: string;
}) {
  if (!footprint) return null;
  const x = (footprint.x - view.x1) * px;
  const y = (footprint.y - view.y1) * px;
  const halfWidth = footprint.halfWidth * px;
  const halfHeight = footprint.halfHeight * px;
  const outline = {
    fill: "#d946ef", fillOpacity: 0.04, stroke: "#d946ef", strokeWidth: 1,
    strokeDasharray: "4 3", vectorEffect: "non-scaling-stroke" as const,
  };
  return <g data-c1-collision-footprint={itemId} data-c1-export-exclude="" pointerEvents="none" aria-hidden="true">
    {footprint.circle
      ? <circle {...outline} cx={x} cy={y} r={halfWidth} />
      : <rect {...outline} x={x - halfWidth} y={y - halfHeight} width={halfWidth * 2} height={halfHeight * 2} />}
  </g>;
}
